import { snapshot } from 'valtio'
import { buildAxiosInstance } from '../../utils/apiUtils'
import { type GlobalCustomerType } from '../../types/GlobalCustomerType'
import { customerProxy } from '../../proxies/customerProxy'
import { customerAddProxy } from './customerAddProxy'

interface Response {
  data: {
    customer: GlobalCustomerType
  } | null
  error: string | null
}

export async function executeCustomerUpdate (): Promise<GlobalCustomerType | undefined> {
  customerProxy.apiCallCustomerUpdate.loading = true
  customerProxy.apiCallCustomerUpdate.error = null
  const { formValues, parentCustomer } = snapshot(customerAddProxy)
  const { customer } = snapshot(customerProxy)
  try {
    const parentCompany = parentCustomer ? parentCustomer.id : null
    const axiosInstance = buildAxiosInstance()
    const response = await axiosInstance.post<Response>('/api/customers/update', {
      addressOne: formValues.streetAddressOne,
      addressTwo: formValues.streetAddressTwo,
      city: formValues.city,
      companyName: formValues.companyName,
      customerId: String(customer?.id),
      email: formValues.email?.toLowerCase(),
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      parentCustomerId: parentCompany,
      postalCode: formValues.postalCode,
      state: formValues.state
    })
    if (response.data.data) {
      return response.data.data.customer
    } else {
      customerProxy.apiCallCustomerUpdate.error = response.data.error
    }
  } catch (e) {
    if (e instanceof Error) {
      customerProxy.apiCallCustomerUpdate.error = e.message
    }
  } finally {
    customerProxy.apiCallCustomerUpdate.loading = false
  }
}
